<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page">
      <div class="col-lg-12">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <div class="logo_form"><img :src="getTranslations.project_logo_img" alt=""></div>
            <div class="form_title">
              <h1>{{ getTranslations.visitor_forgot_password_1_recover_your_password }}</h1>
            </div>
          </div>
          <div class="col-lg-12" v-if="!hasSimplify()">
            <div class="StandardRegSteps_Container">
              <div class="StandardRegSteps_step">1</div>
              <div class="StandardRegSteps_step inactive">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <h1>{{ getTranslations.visitor_forgot_password_1_forgot }}</h1>
              <p>{{ getTranslations.visitor_forgot_password_1_no_worries_msg }}</p>
              <img class="form-help__icon" v-if="!hasResub()" src="static/images/mobile-icon.svg" alt="">
            </div>
            <form action="">
              <div class="form-group form-group--mobile form-group form-group--icon"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="number" class="mobile form-group__textfield phone_input"
                       :placeholder="getTranslations.visitor_forgot_password_1_enter_mobile_number"
                       @keyup="check" v-model="user.msisdn"/>
                <span v-show="getMessage(message) && user.msisdn" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <input type="submit" :value="getTranslations.visitor_forgot_password_1_submit_button_continue"
                     :class="['btn btn--medium btn--main', ( hasErrors ? 'deactivated' : '')]" @click.prevent="checkButton">
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import IntegrationMixin from '@/common/mixins/integration';
import OperatorSelection from './OperatorSelection';

export default {
  name: 'forgotPassword1',
  mixins: [RegistrationFlowMixin, IntegrationMixin],
  components: { OperatorSelection },
  data() {
    return {
      user: {
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      hasStepsToDisplay: false,
      hasValidMsisdn: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setForgotPasswordInfo',
    ]),
    onOperatorChoose(operator) {
      this.hasErrors = false;
      this.message = '';
      this.user.operator = operator;
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    clearData() {
      this.user.msisdn = '';
      this.message = '';
      this.hasErrors = false;
    },
    check() {
      const validMsisdnRegex = /^[0-9]||[()+-]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
        this.hasValidMsisdn = true;
      }
    },
    checkButton() {
      if (!this.hasErrors) {
        this.message = '';
        this.$axios.get(`api/requestNewPin?msisdn=${this.user.msisdn}&lang=${this.getLocale}`).then((response) => {
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.setForgotPasswordInfo(response.data.data);
            this.getNextForgotPasswordStep()();
            this.user.msisdn = '';
            this.message = '';
          } else {
            if (res === 'MSISDN_INVALID') {
              this.message = 'visitor_forgot_password_invalid_msisdn_msg';
            } else if (res === 'ALREADY_REGISTERED') {
              this.message = 'visitor_forgot_password_msisdn_already_registered';
            } else if (res === 'MSISDN_NOT_EXIST') {
              this.message = 'visitor_forgot_password_msisdn_not_exists';
            } else if (res === 'MSISDN_BLACKLISTED') {
              this.message = 'visitor_forgot_password_msisdn_blacklisted';
            } else if (res === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if (res === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'CAMPAIGN_CLOSED') {
              this.message = 'visitor_sign_up_campaign_closed';
            } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword1.vue